import api from './api';

export const birthdayService = {
  // Buscar aniversariantes do mês atual
  async getBirthdayUsers() {
    try {
      const response = await api.get('/users/birthday');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar aniversariantes:', error);
      throw error;
    }
  },

  // Formatar nome do mês
  getMonthName(monthNumber) {
    const months = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    return months[monthNumber - 1] || '';
  },

  // Formatar data de aniversário
  formatBirthday(day, month) {
    const monthName = this.getMonthName(month);
    return `${day} de ${monthName}`;
  }
};
